RivalIQ.module('behaviors', function (behaviors, App, Backbone, Marionette, $, _) {

    'use strict';

    behaviors.TrackedLinks = Marionette.Behavior.extend({
        ui: {
            link: '.x-tracked-link'
        },

        events: {
            'click @ui.link': 'onTrackedLinkClick'
        },

        onTrackedLinkClick: function (e) {
            const $target = $(e.currentTarget);

            const eventName = $target.data('event');
            if (!eventName) {
                RivalIQ.logger.warn('Link tracking expects an event name.');
                return;
            }

            const evnt = _.get(RivalIQ.tracking.metric, [eventName]);
            if (!evnt) {
                RivalIQ.logger.warn(`Link tracking expects an event. Did you define one for "${eventName}?"`);
                return;
            }

            RivalIQ.execute('tracking:push:auth', evnt, {});
        }
    });

});
